import uuid from 'uuid'
import debug from 'debug'

const log = debug('app:store:dialogs')

export const initialState = {
  dialogs: {},
  visibleStack: []
}

export const actionTypes = {
  openDialog: 'dialogs/open',
  closeDialog: 'dialogs/close'
}

const maxDialogsOpened = 4

export const actionCreators = {
  openDialog: (options, id = null) => (dispatch, getState) => {
    if (id === null) id = uuid()
    const dialogs = getState().dialogs
    let alreadyDisplayed = false
    if (dialogs.visibleStack.length > 0) {
      const lastDialog = dialogs.dialogs[dialogs.visibleStack[dialogs.visibleStack.length - 1]]
      if ((options.content && lastDialog.content === options.content) || (options.localizedContent && lastDialog.localizedContent === options.localizedContent)) {
        alreadyDisplayed = true
        log('WARN: Following dialog is already displayed: %o', options)
      }
    }
    if (!alreadyDisplayed) {
      dispatch({ type: actionTypes.openDialog, id, options })
    }
  },
  closeDialog: (id) => (dispatch) => {
    dispatch({ type: actionTypes.closeDialog, id })
  }
}

const openDialog = actionCreators.openDialog
const closeDialog = actionCreators.closeDialog

export {
  openDialog,
  closeDialog
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.openDialog: {
      if (state.visibleStack.length < maxDialogsOpened) {
        return {
          ...state,
          dialogs: { ...state.dialogs, [action.id]: action.options },
          visibleStack: [action.id, ...state.visibleStack]
        }
      }
      break
    }
    case actionTypes.closeDialog: {
      let dialogs = state.dialogs
      delete dialogs[action.id]
      const visibleStack = state.visibleStack.filter(x => x !== action.id)
      return { ...state, dialogs, visibleStack }
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/Dialogs.js